import { gql } from "@apollo/client";

export const reorderItems = gql`
    mutation reorderItems($orderNumber: String!) {
        reorderItems(orderNumber: $orderNumber) {
            cart {
                id
                items {
                    uid
                    product {
                        sku
                    }
                    quantity
                    prices {
                        price {
                            value
                        }
                    }
                }
            }
        }
    }
`;
